import { Link } from "react-router-dom";
import React from "react";
export const SuccessPage = () => {
    return (React.createElement("section", { className: "success-page tc" },
        React.createElement("h3", null, "Vielen Dank f\u00FCr Ihre Buchung"),
        React.createElement("p", null,
            "Wir best\u00E4tigen gerne Ihre Schiffsbesichtigung.",
            React.createElement("br", null),
            "Die Buchungsbest\u00E4tigung mit weiteren Informationen erhalten Sie im Laufe des Tages per E-Mail.",
            React.createElement("br", null),
            "Wir freuen uns auf Ihren Besuch - Herzlich willkommen an Bord!"),
        React.createElement("div", { className: "mt3" },
            React.createElement(Link, { to: "/", className: "btn btn--link mr3" },
                React.createElement("i", { className: "fas fa-arrow-left mr2" }),
                "Weiteren Termin buchen"),
            React.createElement("a", { href: "https://www.phoenixreisen.com", className: "btn btn--link ml3" },
                "Zu unserer Homepage",
                React.createElement("i", { className: "fas fa-arrow-right ml2" })))));
};
export default SuccessPage;
